<template>
    <BlogList
        :breadcrumb-title="data?.collection?.name"
        :categories="data?.postCategories"
        :collection="data?.collection"
        :description="description"
        :meta-title="title"
        :error="error"
        :fetching="fetching"
        :has-data="!!data"
        :page="page"
        :response-errors="responseErrors"
        :stale="stale"
        :title="title"
        @try-again="executeQuery"
    />
</template>

<script lang="ts" setup>
import { computed, provide } from 'vue'
import {
    type PostsByTagQueryVariables,
    usePostsByTagQuery,
} from '@/graphql/api'
import { useTranslator } from '@/i18n'
import { useResponseError } from '@/helpers/errors'

import BlogList from '@/components/cms/component/blog/BlogList.vue'

const props = defineProps<{
    slug: string
    page: number
}>()

const { locale } = useTranslator()

const variables = computed((): PostsByTagQueryVariables => {
    return {
        slug: props.slug,
        page: props.page,
        limit: 10,
        locale: locale.value,
    }
})

const response = usePostsByTagQuery({ variables })
provide('response', response)
await response

const responseErrors = useResponseError(response)

const { fetching, data, error, stale, executeQuery } = response

const title = computed(
    () =>
        data.value && `Posts tagged with "${data.value.collection?.name || ''}"`
)

// TODO translate
const description =
    'Find out all you need to know about engagement rings - from diamond and gemstone guidance to trends and proposal inspiration.'
</script>
